import React, { useState, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import { SmartHoursEditor } from '@bingads-webui-campaign-react/smart-component-business-hours';
import { mapHoursToWSDFormat } from '@bingads-webui-campaign-react/smart-component-util';

import { SmartBookingModal } from './booking-modal-base';
import { proxyReadHoursConfig } from '../utils/proxy-read-hours-config';

const getStyles = () => ({});

export const UnStyledSmartBookingManagement = ({
  i18n,
  isOpen,
  title,
  actionButtonLabel,
  onCloseModal,
}) => {
  const { siteConfig, dispatchSiteConfig } = useContext(SiteConfigContext);

  // Don't change WSD each time, use state as the intermediate cache
  const [bookingHours, setBookingHours] = useState(proxyReadHoursConfig(siteConfig));

  const onTimeChange = useCallback((updatedHours) => {
    setBookingHours(updatedHours);
  }, []);

  const triggerTimeChange = useCallback((updatedHours) => {
    dispatchSiteConfig({
      type: 'UPDATE_WEBSITESOURCEDATA_BY_NAME',
      payload: {
        name: 'Appointment',
        value: {
          AppointmentHours: mapHoursToWSDFormat(updatedHours),
          Services: [],
        },
      },
    });
  }, [dispatchSiteConfig]);

  const onClickSubmit = useCallback(() => {
    triggerTimeChange(bookingHours);
    onCloseModal();
  }, [bookingHours, onCloseModal, triggerTimeChange]);

  return (
    <SmartBookingModal
      i18n={i18n}
      className="editor-booking-modal"
      isOpen={isOpen}
      title={title}
      actionButtonLabel={actionButtonLabel}
      onClickFooterButton={onClickSubmit}
      onCloseModal={onCloseModal}
    >
      <SmartHoursEditor
        id="cta-booking-hours"
        i18n={i18n}
        time={bookingHours}
        onTimeChange={onTimeChange}
        mode="inline"
      />
    </SmartBookingModal>
  );
};

UnStyledSmartBookingManagement.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  actionButtonLabel: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

UnStyledSmartBookingManagement.defaultProps = {};

export const SmartBookingManagement = withDefaultStyles(
  UnStyledSmartBookingManagement,
  getStyles
);
